import { DefaultTheme } from "styled-components";

import { ColorType } from "@sso/types";

export const getColors = (theme: DefaultTheme, _color?: ColorType) => {
  if (!_color) {
    return {
      _color: theme.colors.primary.main,
      _contrastColor: theme.colors.primary.contrastText,
      _hoverColor: theme.colors.primary.dark,
    };
  }
  switch (_color) {
    case "primary":
      return {
        _color: theme.colors.primary.main,
        _contrastColor: theme.colors.primary.contrastText,
        _hoverColor: theme.colors.primary.dark,
      };
    case "secondary":
      return {
        _color: theme.colors.secondary.main,
        _contrastColor: theme.colors.secondary.contrastText,
        _hoverColor: theme.colors.secondary.dark,
      };
    case "secondaryDark":
      return {
        _color: theme.colors.secondary.dark,
        _contrastColor: theme.colors.secondary.contrastText,
        _hoverColor: theme.colors.secondary.dark,
      };
    case "warning":
      return {
        _color: theme.colors.warning.main,
        _contrastColor: theme.colors.warning.contrastText,
        _hoverColor: theme.colors.warning.dark,
      };
    case "success":
      return {
        _color: theme.colors.success.main,
        _contrastColor: theme.colors.success.contrastText,
        _hoverColor: theme.colors.success.dark,
      };
    case "error":
      return {
        _color: theme.colors.error.main,
        _contrastColor: theme.colors.error.contrastText,
        _hoverColor: theme.colors.error.dark,
      };
    case "info":
      return {
        _color: theme.colors.info.main,
        _contrastColor: theme.colors.info.contrastText,
        _hoverColor: theme.colors.info.dark,
      };
    default:
      return { _color, _contrastColor: _color, _hoverColor: _color };
  }
};
